import * as React from 'react';
import './NumberSlider.scss';

export interface INumberSliderProps {
  value: number;
  min: number;
  max: number;
  className?: string;
  onChange?: (value: number) => void;
  onChangeEnd?: (value: number) => void;
}

export const NumberSlider: React.FC<INumberSliderProps> = ({ min, max, value, onChange, onChangeEnd, className }) => {
  const [currentValue, setCurrentValue] = React.useState(value);
  let minValue = min;
  let disabled = false;
  if (min === max) {
    // if value can not be changed - disable input and apply a visual hack to keep looking nice
    minValue = min - 1;
    disabled = true;
  }
  const style = { '--min': minValue, '--max': max, '--val': currentValue };
  const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setCurrentValue(+e.target.value);
    if (onChange) onChange(+e.target.value);
  };
  const onMouseUpHandler = () => {
    if (onChangeEnd) onChangeEnd(currentValue);
  };
  return (
    <div className={`numberSlider ${className ?? ''}`}>
      <input
        style={style as React.CSSProperties}
        type="range"
        min={minValue}
        max={max}
        defaultValue={value}
        onChange={onChangeHandler}
        onMouseUp={onMouseUpHandler}
        disabled={disabled}
        data-testid="number-slider"
      />
    </div>
  );
};

export default NumberSlider;
